export const mapOrder = <T extends Record<string, unknown>>(
  array: T[],
  order: unknown[],
  key: keyof T
): T[] => {
  array.sort((a, b) => {
    const A = a[key];
    const B = b[key];
    if (order.indexOf(A + "") > order.indexOf(B + "")) {
      return 1;
    }
    return -1;
  });
  return array;
};


export const getDateWithFormat = () => {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yyyy = today.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
};

export const getCurrentTime = () => {
  const now = new Date();
  return `${now.getHours()}:${now.getMinutes()}`;
};

export const addCommas = (nStr: string | number): string => {
  const s = String(nStr);
  var x = s.split(".");
  var x1 = x[0];
  var x2 = x.length > 1 ? "." + x[1] : "";
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
  }
  return x1 + x2;
}